import UserService from './user';
import IotService from './iot';
import QiniuService from './qiniu';
import OssService from './oss';
import ProjectService from './project';
import ConnectService from './connect';
import Feedback from './feedback';
import Extension from './extension';
import Sprite from './sprite';

export default {
    UserService,
    IotService,
    QiniuService,
    OssService,
    ProjectService,
    ConnectService,
    Feedback,
    Extension,
    Sprite
};